import gql from 'graphql-tag';

export const QUERY_RETAILER_LISTING = gql`
  query Stores($start: Int = 0) {
    stores(start: $start) {
      id
      name
      category
      type
      partnership
      link
      street
      zip
      city
      phone
      email
      opening_hours
      notification_de
      notification_en
      lat
      lng
    }
  }
`;
